import Costs from './CostsContainer.vue';

export { Costs };



// WEBPACK FOOTER //
// ./src/modules/home/costs/index.js